import { RowDataBuildConfigPrebuild } from "../../components/BuildConfigPrebuildPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the BuildConfigPrebuildTable factory
 */
class BuildConfigPrebuildRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/build-config/read-range-prebuild"
        this.accessData = "builds"
    }

    create(build: any): RowDataBuildConfigPrebuild {
        const rowDataPrebuild: RowDataBuildConfigPrebuild = {
            id: build.id,
            buildId: build.buildId,
            title: build.title,
            images: build.images,
            cpu: build.cpu,
            cooler: build.cooler,
            gpu: build.gpu,
            mobo: build.mobo,
            case: build.case,
            ram: build.ram,
            psu: build.psu,
            ssd1: build.ssd1,
            ssd2: build.ssd2,
            isPrebuild: build.isPrebuild,
            isCustom: build.isCustom,
            isEasy: build.isEasy,
            isBestSeller: build.isBestSeller,
            show: build.show,
            category: build.category,
            action: "",
        };
        return rowDataPrebuild;
    }
}

let buildConfigPrebuildRow: BuildConfigPrebuildRow | null = null;

export default function getBuildConfigPrebuildRow(): BuildConfigPrebuildRow {
    if (buildConfigPrebuildRow === null)
        buildConfigPrebuildRow = new BuildConfigPrebuildRow()
    return buildConfigPrebuildRow
}